import { isMonthDate } from '@web-platform/shared-universal-utils-frontend-localisation';

import { checkIsAnytime, isLocationCityOrAirport } from './searchValidation';

import type { DateString } from '@web-platform/shared-universal-types/src/dateString';
import type { SearchLegPlace } from '@web-platform/shared-universal-types/src/redux/state/appInitial/user/search';

const isCombinedExploreCitySearchWithAnytime = (
  destination: SearchLegPlace | undefined,
  origin: SearchLegPlace | undefined,
  outboundDate: DateString | undefined,
  isAnytime: boolean | undefined,
): boolean => {
  if (!(destination && origin)) {
    return false;
  }

  if (
    [origin, destination].every(isLocationCityOrAirport) &&
    checkIsAnytime(outboundDate, isAnytime)
  ) {
    return true;
  }

  return false;
};

const isCombinedExploreCitySearchWithMonth = (
  destination: SearchLegPlace | undefined,
  origin: SearchLegPlace | undefined,
  outboundDate: DateString | undefined,
): boolean => {
  if (!(destination && origin && outboundDate)) {
    return false;
  }

  if ([origin, destination].every(isLocationCityOrAirport) && isMonthDate(outboundDate)) {
    return true;
  }

  return false;
};

export { isCombinedExploreCitySearchWithMonth, isCombinedExploreCitySearchWithAnytime };
